import { Components } from '@mui/material';

export const typography: Components = {
  MuiTypography: {
    styleOverrides: {
      root: {
        fontFamily: 'CustomFont',
        color: '#66798D',
      },
    },
  },
  MuiGrid2: {
    styleOverrides: {
      root: {
        fontFamily: 'CustomFont',
      },
    },
  },
};
